<template>
  <span class="charge-discharge-statistics">
    <div class="bj"><img src="/static/images/svolt/chongdian-icon.png" /></div>
    <div style="display: flex;justify-content: space-between;margin-top:10px;">
      <ChargeTextBlock direction="left" :data="data.chargeData1"></ChargeTextBlock>
      <ChargeTextBlock direction="right" :data="data.chargeData2"></ChargeTextBlock>
    </div>
    <div style="display: flex;justify-content: space-between;margin-top:15px;">
      <ChargeTextBlock direction="left" :data="data.chargeData3"></ChargeTextBlock>
      <ChargeTextBlock direction="right" :data="data.chargeData4"></ChargeTextBlock>
    </div>
  </span>
</template>

<script>
import ChargeTextBlock from './charge-text-block.vue';
export default {
  components: {
    ChargeTextBlock
  },
  props: {
    data: {
      type: [Object, Array],
      default() {
        return {
          chargeData1: {
            title: '日充电量',
            number: '503.6'
          },
          chargeData2: {
            title: '日放电量',
            number: '503.6'
          },
          chargeData3: {
            title: '总充电量',
            number: '533580.4'
          },
          chargeData4: {
            title: '总放电量',
            number: '533580.4'
          }
        };
      }
    }
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss">
.charge-discharge-statistics {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 26px;
  line-height: 26px;
  display: inline-block;
  .bj {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
    text-align: center;
    width: 100%;
    img {
      width: 145px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/charge-discharge-statistics.vue